// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.allig-success-button .text-color-white[data-v-1544fece] {\r\n  color: #fff;\n}\n.allig-success-button .text-bold[data-v-1544fece] {\r\n  font-weight: bold;\n}\r\n", ""]);
// Exports
module.exports = exports;
